<template>
  <div id="menu" class="w-100">
    <div class="container h-100">
      <div class="row h-100 align-items-center">
        <div class="col-lg-3 col-9">
          <router-link to="/">
            <img src="../assets/img/logo.png" alt="Comcasa" title="Comcasa">
          </router-link>
        </div>
        <div class="col-lg-9 d-none d-lg-block">
          <ul class="d-flex justify-content-end">
            <li>
              <router-link to="/sobre"
              :class="{
                'active' : this.$route.name === 'Sobre' ||
                this.$route.name === 'Historia' ||
                this.$route.name === 'Valores' ||
                this.$route.name === 'Diferenciais' ||
                this.$route.name === 'Empresas'
                }">
                Comcasa
              </router-link>
            </li>
            <li class="submenu">
              <router-link :to="{name: 'Empreendimentos', query: {for_sale: 1}}" :class="{
                'active' : this.$route.name === 'Empreendimentos' ||
                this.$route.name === 'Interna' ||
                this.$route.name === 'InternaApresentacao' ||
                this.$route.name === 'InternaPlantas' ||
                this.$route.name === 'InternaGaleria' ||
                this.$route.name === 'InternaTour' ||
                this.$route.name === 'InternaEstagio' ||
                this.$route.name === 'InternaLocalizacao' ||
                this.$route.name === 'Comparar'
                }">
                Empreendimentos
                <div class="submenu_area">
                  <ul class="row">
                    <li>
                      <router-link :to="{name: 'Empreendimentos', query: {for_sale: 1}}">
                        À Venda
                      </router-link>
                    </li>
                    <li>
                      <router-link :to="{name: 'Empreendimentos', query: {delivered: 1}}">
                        Entregues
                      </router-link>
                    </li>
                    <li>
                      <router-link :to="{name: 'Comparar'}">
                        Comparar imóveis
                      </router-link>
                    </li>
                  </ul>
                </div>
              </router-link>
            </li>
            <li>
              <a href="https://www.comcasa.com.br/cms" target="_blank">
                Portal do cliente
              </a>
            </li>
            <li>
              <router-link to="/blog" :class="{
                'active' : this.$route.name === 'Blog' ||
                this.$route.name === 'BlogInterna'
                }">
                Blog
              </router-link>
            </li>
            <li>
              <router-link to="/contato" :class="{
                'active' : this.$route.name === 'Contato'}">
                Fale conosco
              </router-link>
            </li>
            <li
              class="icons"
              v-for="(item,index) in socialNetworks"
              v-if="item.type == 'facebook' || item.type == 'instagram'"
              :key="index"
            >
              <a :href="item.link" target="_blank">
                <i :class="'fa '+item.icon"></i>
              </a>
            </li>
          </ul>
        </div>
        <div class="col-3 d-block d-lg-none text-right">
          <div class="button_menu" :class="{'open':menuOpen}" @click="activeMenu">
            <a href="#" class="menu-icon-toggle"><span></span></a>
            <i class="menu-background top"></i>
            <i class="menu-background middle"></i>
            <i class="menu-background bottom"></i>
          </div>
          <div class="menu_mobile--open" :class="{'menu_mobile--show': menuOpen}">
            <div class="lista_menu_mobile" @click="menuOpen = false">
              <ul class="row align-items-center">
                <li class="col-12">
                  <router-link to="/sobre">
                    Comcasa
                  </router-link>
                </li>
                <li class="col-12 empreendimentosMenu">
                  <router-link :to="{name: 'Empreendimentos', query: {for_sale: 1}}">
                    Empreendimentos
                  </router-link>
                </li>
                <li class="col-12 empreendimentosMenu subitens">
                  <router-link :to="{name: 'Empreendimentos', query: {for_sale: 1}}">
                    À Venda
                  </router-link>
                </li>
                <li class="col-12 empreendimentosMenu subitens">
                  <router-link :to="{name: 'Empreendimentos', query: {delivered: 1}}">
                    Entregues
                  </router-link>
                </li>
                <li class="col-12 subitens">
                  <router-link :to="{name: 'Comparar'}">
                    Comparar imóveis
                  </router-link>
                </li>
                <li class="col-12">
                  <a href="https://www.comcasa.com.br/cms" target="_blank">
                    Portal do cliente
                  </a>
                </li>
                <li class="col-12">
                  <router-link to="/blog">
                    Blog
                  </router-link>
                </li>
                <li class="col-12">
                  <router-link to="/contato">
                    Fale conosco
                  </router-link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      scrollPosition: null,
      menuOpen: false
    }
  },

  methods: {
    pageScroll () {
      this.scrollPosition = window.scrollY
      if (this.scrollPosition > 200) {
        document.getElementById('menu').classList.add('menu_fixo')
      } else {
        document.getElementById('menu').classList.remove('menu_fixo')
      }
    },
    activeMenu () {
      if (this.menuOpen === true) {
        this.menuOpen = false
        return true
      }
      this.menuOpen = true
    },
    parametros (status) {
      let parametros = {}
      if (status) {
        parametros.status = status
      }
      return parametros
    }
  },
  mounted () {
    window.addEventListener('scroll', this.pageScroll)
  },
  computed: {
    ...mapGetters([
      'socialNetworks'
    ])
  },
  created () {
    this.$store.dispatch('loadSocialNetworks')
  }
}
</script>
<style lang="scss" scoped>
@import '../assets/scss/_variables.scss';

#menu {
  background: rgba(19, 24, 44, 0.3);
  height: 150px;
  position: fixed;
  top: 0px;
  transition: all 0.3s;
  z-index: 51;
  li {
    a{
      color: white;
      font-size: 16px;
      font-weight: 400;
      padding: 10px 15px 20px 15px;
      text-transform: uppercase;
      transition: all 0.3s;
      &:hover {
        color: $green;
      }
    }
    .submenu_area {
      background: white;
      border-radius: 0 0 10px 10px;
      border-top: 3px $green solid;
      box-shadow: 10px 10px 20px 0px rgba(0, 26, 66, 0.2);
      display: none;
      left: 70px;
      padding: 10px 20px;
      position: absolute;
      top: 38px;
      width: 495px;
      &:before {
        background: url(../assets/img/seta_menu.png);
        content: '';
        height: 7px;
        left: 20px;
        position: absolute;
        top: -10px;
        width: 11px;
      }
      li {
        padding: 10px 20px 10px 20px;
        position: relative;
        text-align: center;
        &:before {
          background: $green;
          content: '';
          height: 100%;
          left: -00px;
          position: absolute;
          top: -0px;
          width: 1px;
        }
        a {
          color: $primary;
          font-weight: bold;
          padding: 20px 0px 15px 0px;
          transition: all 0.3s;
          &:hover {
            color: $green;
          }
        }
        &:nth-of-type(1) {
         &:before {
           display: none;
         }
        }
      }
    }
  }
  .icons {
    a {
      padding-right: 0px;
      i {
        font-size: 20px;
      }
    }
  }
  .submenu {
    position: relative;
    &:hover {
      .submenu_area {
        display: block;
      }
    }
  }
  ul {
    margin-bottom: 0px;
  }
  .active {
    font-weight: bold;
    position: relative;
    &:before {
      background: $green;
      bottom: 0px;
      content: '';
      height: 4px;
      left: calc(20% - 10%);
      position: absolute;
      width: 80%;
    }
  }
}
.menu_fixo {
  background: $primary!important;
  box-shadow: 0px 5px 10px 0px rgba(114,114,119, 0.2);
  height: 100px!important;
  transition: all 0.3s;
  z-index: 200;
}

.menu_mobile--open {
  background: $primary;
  height: 85vh;
  bottom: 0;
  right: -100vw;
  padding: 80px 25px 25px 25px;
  position: fixed;
  text-align: center;
  transition: all 0.4s;
  width: 100vw;
  z-index: 50;
  li {
    margin-bottom: 15px;
    a {
      color: white;
      font-size: 20px;
    }
  }
}
.menu_mobile--show{
  right: 0;
}
.menu_mobile--close {
  color: white;
  cursor: pointer;
  font-size: 30px;
  position: absolute;
  right: 25px;
  top: 60px;
}
.lista_menu_mobile {
  .empreendimentosMenu {
    margin-bottom: 10px;
  }
  .subitens {
    padding-bottom: 5px;
    a {
      font-size: 18px!important;
    }
  }
  li {
    margin-bottom: 30px;
    a {
      font-weight: bold!important;
      font-size: 24px!important;
    }
  }
}
@media (max-width: 1400px) {
  #menu {
    height: 120px;
  }
}
@media (max-width: 1200px) {
  #menu {
    li {
      a {
        font-size: 15px;
        padding: 10px 5px 20px 5px;
      }
      .submenu_area {
        width: 466px;
        left: 20px;
      }
    }
  }
}
@media (max-width: 991px) {
  #menu {
    z-index: 60;
    background: #13182c !important;
    height: 15vh!important;
  }
}

.menu-icon-toggle {
  display: block;
  width: 40px;
  height: 40px;
  position: relative;
  z-index: 9;
  .home & {
    top: 50px;
    position: absolute;
    right: 20px;
    top: 20px;
  }
  span {
    display: block;
    width: 100%;
    height: 2px;
    position: absolute;
    top: 50%;
    background-color: white;
    transform: translate(0, -50%);
    transition: opacity 0.2s 0.2s;
    .home:not(.open) & {
      background-color: white;
    }
  }
  &::before,
  &::after {
    content: '';
    display: block;
    width: 100%;
    height: 2px;
    position: absolute;
    background-color: white;
    transition: transform 0.2s, top 0.2s 0.2s, bottom 0.2s 0.2s;
  }
  &::before {
    top: 6px;
  }
  &::after {
    bottom: 6px;
  }
  .open & {
    span {
      opacity: 0;
      transition: opacity 0.2s;
    }
    &::before,
    &::after {
      background-color: white;
    }
    &::before {
      top: calc(50% - 1px);
      transform: rotate(45deg);
    }
    &::after {
      bottom: calc(50% - 1px);
      transform: rotate(-45deg);
    }
    &::before,
    &::after {
      transition: top 0.2s, bottom 0.2s, transform 0.2s 0.2s;
    }
  }
}
.button_menu__open {
  position: absolute;
  right: 30px;
  top: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/Menu.vue